export default "__VITE_PUBLIC_ASSET__806b4c4f__"